module.exports = __webpack_public_path__ + "img/creico.ff7792dd.png";